import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onSearchDialogResultHighlighted = ({
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
}: {
	actionSubjectId: string;
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	source: 'searchDialog',
	eventType: 'ui',
	action: 'highlighted',
	actionSubject: 'searchResult',
	actionSubjectId,
	attributes,
	nonPrivacySafeAttributes,
});
